import { Button, FormBuilder, Div, KeyboardAwareArea, Label, Touchable } from "@grassrootly/rn-core";
import { Logo } from "../../layout/components/logo";
import { loginForm } from "./Login.types";
import { useLogin } from "./useLogin";
import { Platform, ScrollView, Text } from "react-native";

export default function LoginScreen() {
  const { login, loading, gotToForgotPassword, gotToRegister, insents } = useLogin();

  return (
    <Div
      classNames={[
        "flex1",
        "borderPrimary",
        "bgNeutralDarkerDark",
        "p16",
        `pb-{${insents.bottom + 16 + (Platform.OS == "web" ? 16 : 0)}}`,
        "h100",
      ]}
    >
      <KeyboardAwareArea dismissKeyboardOnPress>
        <ScrollView style={{ flex: 1 }} showsVerticalScrollIndicator={false}>
          <Div classNames={["flex1", "alignItemsCenter", "justifyContentCenter", "pt-{64}", "ph16"]}>
            <Logo width={100} height={100} />
            <Text style={{ color: "#1ABC6C", fontSize: 32, fontWeight: "bold", marginTop: 8 }}>
              eqipa
            </Text>
            <Div classNames={["mt-{20}", "w-{100%}", "maxW-{300}"]}>
              <FormBuilder
                form={loginForm}
                onSubmit={login}
                submitControl={(submit) => (
                  <>
                    <Touchable onPress={gotToForgotPassword}>
                      <Label type="l3Regular" classNames={["underline"]}>
                        Forgot password?
                      </Label>
                    </Touchable>
                    <Button
                      title="Log in"
                      onPress={submit}
                      type="button"
                      classNames={["btn", "btnBlock", "btnPrimary", "mt-{22}"]}
                      isLoading={loading}
                      disabled={loading}
                    />
                    <Touchable onPress={gotToRegister}>
                      <Label type="l3Regular" classNames={["underline", "textCenter", "mt-{4}"]}>
                        Don't have an account? Register here.
                      </Label>
                    </Touchable>
                    <Label classNames={["l4Regular", "textCenter"]}>
                      {process.env.EXPO_PUBLIC_SUPABASE_ENV} - v{process.env.EXPO_PUBLIC_APP_VERSION}</Label>
                  </>
                )}
                submitFormOnEnter={true}
              />
            </Div>
          </Div>
        </ScrollView>
      </KeyboardAwareArea>
    </Div>
  );
}
